module.exports = __webpack_public_path__ + "static/scholarjet-mission-3241ca13bafc2fee973361313a48ec67.gif";